import icon from "@material-ui/icons/Store"

export default { icon } ;